import type { DataContext, ReportTemplate } from '../schemas';
import { evaluateTemplateExpression } from '../templateExpressions';

function isVisibilityTruthy(value: unknown): boolean {
  if (value === undefined || value === null) return false;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return Number.isFinite(value) && value !== 0;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (!normalized) return false;
    if (normalized === 'false') return false;
    if (normalized === '0') return false;
    return true;
  }
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

export function evaluateSectionVisibility(options: {
  template: ReportTemplate;
  context: DataContext;
}): string[] {
  const { template, context } = options;

  const applicable: string[] = [];
  const recordContext = context as unknown as Record<string, unknown>;

  for (const section of template.sections) {
    if (!section.visibleIf) {
      applicable.push(section.id);
      continue;
    }

    const result = evaluateTemplateExpression(section.visibleIf, recordContext);
    if (isVisibilityTruthy(result)) {
      applicable.push(section.id);
    }
  }

  return applicable;
}
